/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { ImageProto } from './image-proto';

export class IntImagePair {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): IntImagePair {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsIntImagePair(bb: flatbuffers.ByteBuffer, obj?: IntImagePair): IntImagePair {
    return (obj || new IntImagePair()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsIntImagePair(
    bb: flatbuffers.ByteBuffer,
    obj?: IntImagePair,
  ): IntImagePair {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new IntImagePair()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  key(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  value(obj?: ImageProto): ImageProto | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new ImageProto()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startIntImagePair(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addKey(builder: flatbuffers.Builder, key: number) {
    builder.addFieldInt32(0, key, 0);
  }

  static addValue(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, valueOffset, 0);
  }

  static endIntImagePair(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }
}
